import { useState } from 'react';
import QRCode from 'qrcode';
import { createRooms } from '../../api/rooms.api';
import { API } from '../../config/routes';

export function useRooms() {
  const [qrCodes, setQrCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateQRCodes = async (songLimit, qrCount, spotifyAccountId) => {
    setLoading(true);
    setError(null);
    try {
      const { roomIds, qrcodes } = await createRooms(songLimit, qrCount, spotifyAccountId);
      const items = await Promise.all(
        qrcodes.map(async (token, i) => {
          const roomId = roomIds[i];
          const url = `${API.QR_SCAN_BASE_URL}?token=${token}`;
          const dataUrl = await QRCode.toDataURL(url, { margin: 1, scale: 6, errorCorrectionLevel: 'M' });
          return { roomId, token, dataUrl, url, songLimit };
        })
      );
      setQrCodes(items);
    } catch (err) {
      setError('Error generando QR codes');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { qrCodes, loading, error, generateQRCodes };
}
